import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-marquee').each((index, marquee) => {
  const $marquee = $(marquee);

  let tickerSpeed = 0.75;
  let isPaused = false;

  $marquee.flickity({
    arrowShape:
      'M0 50c0 .77.467 1.795.94 2.292l26.666 28.334c1.245 1.287 3.262 1.436 4.714.13 1.298-1.168 1.33-3.445.13-4.714l-21.406-22.71h85.623a3.333 3.333 0 1 0 0-6.666H11.044l21.406-22.71c1.2-1.267 1.115-3.49-.13-4.713-1.314-1.292-3.488-1.177-4.714.13L.94 47.709c-.784.768-.927 1.509-.94 2.29z',
    contain: true,
    draggable: true,
    lazyLoad: true,
    pageDots: false,
    prevNextButtons: true,
    wrapAround: true,
  });

  const flickity = $marquee.data('flickity');

  flickity.x = 0;

  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };

  const pause = () => {
    isPaused = true;
  };

  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };

  $marquee.on('mouseenter', pause);
  $marquee.on('mouseleave', play);
  $marquee.on('focusin', pause);
  $marquee.on('focusout', play);

  flickity.on('dragStart', () => {
    isPaused = true;
  });

  update();
});
